import Splide, { ResponsiveOptions } from '@splidejs/splide';
import CMSHelper from '../../helpers/cms-helper';

enum LevelOfDetail {
  Low = 'LOW',
  Normal = 'NORMAL'
}

const selectors = {
  container: '.js-carousel',
  items: '.js-items',
  nextButton: '.js-next',
  previousButton: '.js-prev',
  slide: '.splide__slide',
  slideVisible: '.is-visible',
};

export default class Carousel {
  constructor(container: HTMLElement) {
    const itemsContainer = container.querySelector(selectors.items) as HTMLElement;
    const numSlides = itemsContainer.querySelectorAll(selectors.slide).length;
    const nextButton = container.querySelector<HTMLButtonElement>(selectors.nextButton) as HTMLButtonElement;
    const prevButton = container.querySelector<HTMLButtonElement>(selectors.previousButton) as HTMLButtonElement;

    const levelOfDetail = container.dataset.levelOfDetail as LevelOfDetail;
    const isHalfWidthComponent = CMSHelper.isHalfWidthComponent(container);

    let breakpoints: Record<string | number, ResponsiveOptions>;
    let perPage: number;
    if (isHalfWidthComponent) {
      perPage = 3;
      breakpoints = {
        640: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
        1200: {
          perPage: 1,
        },
        1600: {
          perPage: 2,
        },
      };
    } else if (levelOfDetail === LevelOfDetail.Low) {
      perPage = 6;
      breakpoints = {
        640: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
        1200: {
          perPage: 3,
        },
        1600: {
          perPage: 4,
        },
      };
    } else {
      perPage = 6;
      breakpoints = {
        640: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
        1200: {
          perPage: 3,
        },
      };
    }

    const slider = new Splide(itemsContainer, {
      type: 'slide',
      pagination: false,
      arrows: false,
      perMove: 1,
      gap: 15,
      perPage,
      breakpoints,
    });

    slider.mount();

    slider.on('resize', () => {
      const visibleSlides = itemsContainer.querySelectorAll(selectors.slideVisible).length;
      container.classList.toggle('-hide-buttons', visibleSlides === numSlides);
    });

    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      slider.go('<');
    });

    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      slider.go('>');
    });

    container.classList.remove(selectors.container.slice(1));
  }

  static initAll(): Carousel[] {
    return Array.from(document.querySelectorAll<HTMLElement>(selectors.container))
      .map((element) => new Carousel(element));
  }
}
